import styled from '@emotion/styled';
import { Modal as AntdModal } from 'antd';
import type { ModalProps as AntdModalProps } from 'antd';
import tw from 'twin.macro';

const Modal = ({ children, ...rest }: AntdModalProps) => {
  return (
    <StyledModal centered {...rest}>
      {children}
    </StyledModal>
  );
};

export default Modal;

const StyledModal = styled(AntdModal)`
  .ant-modal-title {
    ${tw`font-bold text-center`}
  }

  .ant-modal-footer {
    ${tw`text-center`}
  }
`;
